import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as BuyIcon } from '../../../assets/icons/e_i_buy.svg';
import { ReactComponent as RedxIcon } from '../../../assets/icons/redX.svg';
import { ReactComponent as RedPlusIcon } from '../../../assets/icons/redPlus.svg';
import { ReactComponent as GreenEyeIcon } from '../../../assets/icons/greenEye.svg';
import './Legende.scss';
import { ReactComponent as IconInnovation } from '../../../assets/icons/e_i_innovation.svg';
import { ReactComponent as CopyIcon } from '../../../assets/icons/copy.svg';
import { ReactComponent as UploadIcon } from '../../../assets/icons/e_i_upload.svg';
import { Button } from '@repo/apg-ui';
import { bindActionCreators, Dispatch } from 'redux';
import * as actions from '../../../actions';
import * as actionsJourney from '../../../actions/journey1';
import * as actionsCheckout from '../../../actions/checkout';
import * as actionsSujet from '../../../actions/sujet';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';

const Legende = () => {
  const navigate = useNavigate();

  return (
    <div className='legende-modal' id='root'>
      <div className='close-modal'>
        <Button
          onClick={() => {
            navigate({ search: '' });
          }}
        >
          <FormattedMessage id='ec.confirmation.close' defaultMessage='Schliessen' />
          <RedxIcon />
        </Button>
      </div>
      <p className='font-weight-bold mb-4 title'>
        <FormattedMessage
          id='ec.confirmation.legendeGestaltungProduktion'
          defaultMessage='Legende Gestaltungs- und Produktions-Service'
        />
      </p>
      <p className='mb-3 normal-text'>
        <FormattedMessage
          id='ec.confirmation.textOne'
          defaultMessage='Wir unterstützen Sie gerne bei Ihrer gebuchten Kampagne mit unseren Services zur Gestaltung und Anlieferung Ihres Spots sowie der Abwicklung Ihres Druckauftrags bei einer Druckerei nach Ihrer Wahl.'
        />
      </p>
      <p className='mb-48 normal-text'>
        <FormattedMessage
          id='ec.confirmation.textTwo'
          defaultMessage='Unten finden Sie die Erklärung zu den Symbolen der einzelnen Services und deren Status.'
        />
      </p>

      <div className='d-flex flex-column mb-4'>
        <div className='row mb-24 funktionen'>
          <div className='col-6 d-flex align-items-center'>
            <div className='legende-icon'>
              <RedPlusIcon className='me-3' />
            </div>
            <p className='normal-text'>
              <FormattedMessage
                id='ec.confirmation.gestaltung'
                defaultMessage='Gestaltungs- oder Druckauftrag erteilen'
              />
            </p>
          </div>
          <div className='col-6 d-flex align-items-center'>
            <div className='legende-icon'>
              <GreenEyeIcon className='me-3' />
            </div>
            <p className='normal-text'>
              <FormattedMessage
                id='ec.confirmation.erteilterAuftragAnsehen'
                defaultMessage='Erteilter Auftrag ansehen'
              />
            </p>
          </div>
        </div>
        <div className='row mb-24 funktionen'>
          <div className='col-6 d-flex align-items-center'>
            <div className='legende-icon'>
              <UploadIcon className='me-3' />
            </div>
            <p className='normal-text'>
              <FormattedMessage id='ec.confirmation.spotanlieferungUpload' defaultMessage='Spotanlieferung/Upload' />
            </p>
          </div>
          <div className='col-6 d-flex align-items-center'>
            <div className='legende-icon'>
              <RedxIcon className='me-3' />
            </div>
            <p className='normal-text'>
              <FormattedMessage id='ec.confirmation.serviceNichtVerfügbar' defaultMessage='Service nicht verfügbar' />
            </p>
          </div>
        </div>
        <div className='row mb-24 funktionen'>
          <div className='col-6 d-flex align-items-center'>
            <div className='legende-icon'>
              <BuyIcon className='me-3 color-red' />
            </div>
            <p className='normal-text'>
              <FormattedMessage
                id='ec.confirmation.vorlagenUndSpezifikationen'
                defaultMessage='Vorlagen und Spezifikationen'
              />
            </p>
          </div>
          <div className='col-6 d-flex align-items-center'>
            <div className='legende-icon'>
              <CopyIcon className='me-3 color-red' />
            </div>
            <p className='normal-text'>
              <FormattedMessage id='ec.confirmation.copyCampaign' defaultMessage='Kampagne nochmals buchen' />
            </p>
          </div>
        </div>

        <div className='row mt-48'>
          <div className='col-12 d-flex'>
            <div>
              <IconInnovation className='me-3' />
            </div>
            <p className='mini-text'>
              <FormattedMessage
                id='ec.confirmation.legendeMiniText'
                defaultMessage='Alle Druck- und Gestaltungsaufträge werden über externe Partner angeboten. Die Abwicklung sowie auch die Verrechnung wird jeweils direkt zwischen dem Kunden und dem beauftragten Partner abgewickelt.'
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsJourney: bindActionCreators(actionsJourney as any, dispatch),
    actionsCheckout: bindActionCreators(actionsCheckout as any, dispatch),
    actionsSujet: bindActionCreators(actionsSujet as any, dispatch),
    dispatch: dispatch,
  };
}

export default connect(null, mapDispatchToProps)(Legende);
